/**
 * Feature Flags Service
 * Centralized service for managing feature flags
 */
class FeatureFlagsService {
    private static instance: FeatureFlagsService;
    private flags: Map<string, boolean> = new Map();

    private constructor() {
        // Initialize default feature flags
        // Table sorting is enabled by default for all users
        // To disable: FeatureFlagsService.getInstance().disable('tableSorting')
        this.flags.set('tableSorting', true);
    }

    public static getInstance(): FeatureFlagsService {
        if (!FeatureFlagsService.instance) {
            FeatureFlagsService.instance = new FeatureFlagsService();
        }
        return FeatureFlagsService.instance;
    }

    /**
     * Check if a feature flag is enabled
     */
    public isEnabled(flagName: string): boolean {
        return this.flags.get(flagName) ?? false;
    }

    /**
     * Enable a feature flag
     */
    public enable(flagName: string): void {
        this.flags.set(flagName, true);
    }

    /**
     * Disable a feature flag
     */
    public disable(flagName: string): void {
        this.flags.set(flagName, false);
    }

    /**
     * Set a feature flag value
     */
    public set(flagName: string, value: boolean): void {
        this.flags.set(flagName, value);
    }

    /**
     * Get all feature flags
     */
    public getAllFlags(): Map<string, boolean> {
        return new Map(this.flags);
    }
}

export default FeatureFlagsService;

